export default __webpack_public_path__ + "static/media/documenticonactive.ca7084ee.svg";